import { Controller } from "@hotwired/stimulus";

export default class ScrollTransitionController extends Controller {
  lastScroll = 0;
  translateY = 0;

  connect() {
    // Инициализируем lastScroll с защитой от overscroll
    const maxScroll = Math.max(
      0,
      document.body.scrollHeight - window.innerHeight,
    );
    this.lastScroll = Math.max(0, Math.min(window.scrollY, maxScroll));

    this.boundOnScroll = this.onScroll.bind(this);
    document.addEventListener("scroll", this.boundOnScroll);

    this.element.style.transition = "transform 0.3s ease-out";
    this.element.style.transform = "translateY(0px)";
  }

  disconnect() {
    document.removeEventListener("scroll", this.boundOnScroll);
  }

  onScroll() {
    const currentScroll = window.scrollY;

    // Защита от overscroll в iOS Safari - ограничиваем значения scroll
    const maxScroll = Math.max(
      0,
      document.body.scrollHeight - window.innerHeight,
    );
    const clampedCurrentScroll = Math.max(
      0,
      Math.min(currentScroll, maxScroll),
    );
    const clampedLastScroll = Math.max(0, Math.min(this.lastScroll, maxScroll));

    const delta = clampedCurrentScroll - clampedLastScroll;

    const maxTranslateY = -300; // макс смещение вверх

    // Получаем размеры и позицию элемента относительно окна
    const rect = this.element.getBoundingClientRect();

    // Высота элемента
    const height = rect.height;

    // Рассчитываем, какая часть элемента видна на экране (от 0 до 1)
    let visibleRatio = 0;

    if (rect.bottom <= 0) {
      visibleRatio = 0; // элемент полностью за верхом окна
    } else if (rect.top >= window.innerHeight) {
      visibleRatio = 0; // элемент полностью за нижним краем
    } else {
      // вычисляем видимую высоту
      const visibleHeight =
        Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      visibleRatio = visibleHeight / height;
    }

    // Если видно меньше половины монетки — ускоряем движение вверх
    const speedFactor = visibleRatio < 0.5 ? 4 : 1;

    // Проверяем на overscroll - если текущий scroll выходит за пределы, сбрасываем translateY
    if (currentScroll < 0 || currentScroll > maxScroll) {
      // При overscroll возвращаем элемент в исходное положение
      this.translateY = Math.max(0, Math.min(this.translateY, 0));
    } else {
      if (delta > 0) {
        // Скроллим вниз — двигаем монетку вверх с учетом скорости
        this.translateY -= delta * 1 * speedFactor;
        if (this.translateY < maxTranslateY) this.translateY = maxTranslateY;
      } else if (delta < 0) {
        // Скроллим вверх — возвращаем монетку вниз с обычной скоростью
        this.translateY -= delta * 2;
        if (this.translateY > 0) this.translateY = 0;
      }
    }

    this.element.style.transform = `translateY(${this.translateY.toFixed(1)}px)`;

    // Используем clamped значение для последнего scroll
    this.lastScroll = clampedCurrentScroll;
  }
}
